<template>
  <el-col :span="colSpan">
    <el-form-item :label="$locale('shop.purchasePrice_taxIncluded')" :prop="taxIncludeName">
      <el-input v-model="formData[taxIncludeName]" maxlength="20" @change="value => changeAction(value, 'DEC', this.taxIncludeName)">
        <template slot="prepend">¥</template>
      </el-input>
    </el-form-item>

    <el-form-item :label="$locale('shop.purchasePrice_nonTax')" class="not-tax-price" :prop="nonTaxName">
      <el-input v-model="formData[nonTaxName]" maxlength="20" @change="value => changeAction(value, 'INC', this.nonTaxName)">
        <template slot="prepend">¥</template>
      </el-input>
    </el-form-item>
  </el-col>
</template>

<script>
import { taxRateTranf, calcTax } from "@/utils/common";
import { taxOffDec, taxAddDec } from "@/utils/math";
import { decimal2 } from "@/utils/utils";

export default {
  name: "shop-product-price",
  props: {
    formData: {
      required: true,
      type: Object,
    },
    taxRate: {
      required: true,
      type: [String, Number],
    },
    taxIncludeName: {
      type: String,
      default: "productCost",
    },
    nonTaxName: {
      type: String,
      default: "priceWithoutTax",
    },
    colSpan: {
      type: Number,
      default: 24,
    },
    roundType: {
      type: String,
      default: "ROUND"
    },
  },
  data() {
    return {
      decimal2,
    };
  },
  watch: {
    taxRate() {
      this.updateFieldValue(this.formData[this.taxIncludeName], false);
    }
  },
  methods: {
    changeAction(value, type, key) {
      const _value = decimal2(value)
      this.formData[key] = _value
      if (type === "INC") {
        this.updateFieldValue(_value, true);
      } else if (type === "DEC") {
        this.updateFieldValue(_value, false);
      }
    },
    updateFieldValue(value, isIncreaseTax) {
      console.log(value)
      const { taxRate, nonTaxName, taxIncludeName, roundType } = this;
      const _taxRate = typeof taxRate === "string" ? taxRateTranf(taxRate) : taxRate;
      const _val = isIncreaseTax ? taxAddDec(value, _taxRate, roundType) : taxOffDec(value, _taxRate, roundType);
      

      if (isIncreaseTax) {
        this.formData[taxIncludeName] = _val;
      } else {
        this.formData[nonTaxName] = _val;
      }
    },
  },
};
</script>